module.exports = __webpack_public_path__ + "static/media/SanAntonio.56802f49.jpg";